import React, { Component } from 'react';
import moment from 'moment';
import SashiDo from 'lib/SashiDo';

import BarChart from 'components/Charts/BarChart.react';
import SegmentSelect from 'components/SegmentSelect/SegmentSelect.react';

export default class GraphBuilds extends Component {
  constructor(props) {
    super(props);
  }

  shouldComponentUpdate(nextProps) {
    if (!nextProps && this.props === nextProps) {
      return false;
    }

    return true;
  }

  render() {
    return (
      <BarChart
        title={this.props.title}
        desc={this.props.desc}
        tooltip={this.props.tooltip}
        type={this.props.chartType || 'bar'}
        unit={this.props.unit}
        billingDate={null}
        stacked={this.props.stacked}
        dataFormat={this.props.dataFormat}
        toolTipDataFormat={this.props.toolTipDataFormat}
        segmentTime={'30'}
        data={this.props.data}
        height={260}
        customLegend
        colors={this.props.colors}
      />
    );
  }
}
